import { AlignType, EntityType, IComponent, ResizeOptions } from "@multiweb/picasso";
import { bridge } from "@multiweb/reactCore/bridge";
import { Activity } from "./workflowModel";

const { generateUUID } = bridge;

export class UiActivity implements IComponent {
    public readonly id: string;
    public readonly index: number;
    public readonly type: EntityType = EntityType.component;
    public readonly relativeLeft: number;
    public readonly relativeTop: number;
    public readonly width: number;
    public readonly height: number;
    public readonly linkIndexes: readonly number[] = [];
    public readonly parent: number;
    public readonly children: readonly number[] = [];
    public readonly name: string = "activity";
    public readonly minWidth: number = 50;
    public readonly minHeight: number = 50;
    public readonly activity: Activity;
    public readonly setId: string;
    public readonly isVisible: boolean = true;
    public readonly align: AlignType = AlignType.none;
    public readonly resizeOption: ResizeOptions = ResizeOptions.none;
    public readonly noCssHeight?: boolean | undefined;

    constructor(index: number, left: number, top: number, width: number, height: number, setId: string, parentIndex: number, activity: Activity) {
        this.id = generateUUID();
        this.index = index;
        this.relativeLeft = left;
        this.relativeTop = top;
        this.width = width;
        this.height = height;
        this.setId = setId;
        this.parent = parentIndex;
        this.activity = activity;

        this._changeActivityPosition(left, top, width, height);
    }

    private _changeActivityPosition(relativeLeft: number, relativeTop: number, width: number, height: number): void {
        const activitiesPosition = this.activity.positions.find(position => position.set.id === this.setId);

        if (!activitiesPosition)
            throw new Error(`Could not find position with set id of '${this.setId}'`);

        activitiesPosition.x = relativeLeft;
        activitiesPosition.y = relativeTop;
        activitiesPosition.width = width;
        activitiesPosition.height = height;
    }
}
